let animationTimer = undefined;
let animationWidgetTimer = undefined;

let activeAnimationContext = "";
let disableAllAnimations = false;

let preloading : any = {};
export const ANIMATION_DASHBOARD_LOADING_CONTEXT = "dashboard";
export const ANIMATION_EDIT_LOADING_CONTEXT = "edit";
export const ANIMATION_VIEW_LOADING_CONTEXT = "view";

export class AnimationService {

  public static resetPreloadForm = (formName) => {
    preloading[formName] = "";
  }

  public static startPreloadForm = (formName) => {
    preloading[formName] = "start";
  }

  public static finishPreloadForm = (formName) => {
    preloading[formName] = "finish";
  }

  public static disableAnimationsForForm = (formName) => {
    preloading[formName] = "no-animations";
    disableAllAnimations = true;
  }

  public static getAnimationStateForForm = (formName) => {
    if (!!disableAllAnimations) {
      return "no-animations";
    }
    return preloading[formName] || "";
  }

  public static triggerAnimationBlock = (element, loop) => {
    setTimeout(() => {
      element.classList.add("animation__fade-in--trigger");
    }, (loop) * 125);
  }

  public static triggerAnimationWidget = (widget, loop, delay) => {
    widget.classList.add("mijn-fnv__widget--fade-in");   
  }

  public static enableFormAnimations() {
    disableAllAnimations = false;
  }
  
  public static enableAnimations(animationContext) {
    activeAnimationContext = animationContext;
    
  }
  
  public static disableAnimations() {
    activeAnimationContext = "";
  }

  public static triggerAnimations() {
    if (activeAnimationContext === ANIMATION_DASHBOARD_LOADING_CONTEXT ||
        activeAnimationContext === ANIMATION_EDIT_LOADING_CONTEXT ||
        activeAnimationContext === ANIMATION_VIEW_LOADING_CONTEXT)  {
      if (animationTimer) {
        clearTimeout(animationTimer);
        animationTimer = undefined;
      }

      if (animationWidgetTimer) {
        clearTimeout(animationWidgetTimer);
        animationWidgetTimer = undefined;
      }

      animationTimer = setTimeout(() => {
        const widgets = document.querySelectorAll(".mijn-fnv__widget");

        let isPreloading = false;
        for (let loop = 0; loop < widgets.length; loop++) {
            const widget = widgets[loop];                
            if (widget.classList.contains('mijn-fnv__widget--preloading')) {
                isPreloading = true;
            }
        }

        let elements = document.querySelectorAll(".content__background.content__background--loading");
        if (elements.length > 0) {
          isPreloading = true;
        }

        if (!isPreloading) {
          
            elements = document.querySelectorAll(".animation__fade-in");
            for (let loop = 0; loop < elements.length; loop++) {
              const element = elements[loop];                
              AnimationService.triggerAnimationBlock(element, loop);
            }
            animationWidgetTimer = setTimeout(() => {
              for (let loop = 0; loop < widgets.length; loop++) {
                  const widget = widgets[loop];                
                  AnimationService.triggerAnimationWidget(widget, loop, elements.length * 250);
              }
            }, elements.length * 175);
        }
      }, 15);
    }
  }
}